import React, { FC } from 'react';
import { Tab, Typography } from '@getgo/chameleon-web/react';
import i18n from '../../../i18n';

export interface AgendaHeaderProps {
  eventDetailDates: any[];
  handleEventDateTabChange: (eventDate: any) => void;
}

const AgendaHeader: FC<AgendaHeaderProps> = ({ eventDetailDates, handleEventDateTabChange }) => (
  <>
    {eventDetailDates?.map((eventDate: any, index: number) => {
      const [weekDay, dayMonth] = new Date(eventDate.eventDate)
        .toLocaleDateString(i18n.language, { weekday: 'short', month: 'long', day: 'numeric' })
        .split(',');
      return (
        <Tab
          key={eventDate.eventDate + 'tab'}
          className={`agenda-tab-header ${eventDetailDates.length === 1 ? 'cursor-default' : ''}`}
          /*
            // @ts-ignore */
          id={index}
          onClick={() => handleEventDateTabChange(eventDate)}
        >
          <div>
            <Typography className="agenda-event agenda-weekday" variant="button-text-xlarge">
              {weekDay}
            </Typography>
            <Typography
              className="agenda-event agenda-event-daymonth"
              color="text-02"
              variant="caption-default-02"
            >
              {dayMonth}
            </Typography>
          </div>
        </Tab>
      );
    })}
  </>
);

export default AgendaHeader;
